import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);
  }
  return _createClass(Base, [{
    key: "extend",
    value:
    // 对象或数组深度拷贝
    function extend() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if ({}.toString.call(source) === "[object Object]") {
        if ({}.toString.call(target) !== "[object Object]") {
          target = {};
        }
        for (var key in source) {
          if (source.hasOwnProperty(key)) {
            var sourceType = {}.toString.call(source[key]);
            if (sourceType !== "[object Undefined]") {
              var targetType = {}.toString.call(target[key]);
              if (sourceType === "[object Object]") {
                if (targetType !== "[object Object]") {
                  target[key] = {};
                }
                this.extend(target[key], source[key]);
              } else if (sourceType === "[object Array]") {
                if (targetType !== "[object Array]") {
                  target[key] = [];
                }
                this.extend(target[key], source[key]);
              } else {
                target[key] = source[key];
              }
            }
          }
        }
      } else if ({}.toString.call(source) === "[object Array]") {
        if ({}.toString.call(target) !== "[object Array]") {
          target = [];
        }
        for (var i = 0, length = source.length; i < length; i++) {
          var _sourceType = {}.toString.call(source[i]);
          if (_sourceType !== "[object Undefined]") {
            var _targetType = {}.toString.call(target[i]);
            if (_sourceType === "[object Object]" && _targetType !== "[object Object]") {
              target[i] = {};
            } else if (_sourceType === "[object Array]" && _targetType !== "[object Array]") {
              target[i] = [];
            } else {
              target[i] = source[i];
              continue;
            }
            this.extend(target[i], source[i]);
          }
        }
      }
      for (var _len = arguments.length, last = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        last[_key - 2] = arguments[_key];
      }
      if (last.length > 0) {
        return this.extend.apply(this, [target].concat(last));
      }
      return target;
    }
  }]);
}();